import request from '@/config/request.js'
import settings from '@/config/settings.js'
import VueGridLayout from 'vue-grid-layout'
import common from '@/components/common/'
const ApiHome = request.Home
const ApiUser = request.UserLogin
export default {
  name: 'home-index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    ...common
  },
  data () {
    const validateStrongPassword = (rule, value, callback) => {
      void rule
      const s = String(value == null ? '' : value)
      if (!s) return callback(new Error('请输入新密码'))
      if (s.length < 8) return callback(new Error('密码至少8位'))
      if (!/[A-Za-z]/.test(s)) return callback(new Error('密码需包含字母'))
      if (!/\d/.test(s)) return callback(new Error('密码需包含数字'))
      if (this.pwdPolicyForm.confirmPassword) {
        this.$refs.pwdPolicyFormRef &&
          this.$refs.pwdPolicyFormRef.validateField &&
          this.$refs.pwdPolicyFormRef.validateField('confirmPassword')
      }
      callback()
    }
    const validateConfirmPassword = (rule, value, callback) => {
      void rule
      const s = String(value == null ? '' : value)
      if (!s) return callback(new Error('请再次输入密码'))
      if (s !== this.pwdPolicyForm.newPassword) {
        return callback(new Error('两次输入密码不一致!'))
      }
      callback()
    }
    return {
      screenWidth: document.body.clientWidth,
      myStudent: '',
      myTeacher: '',
      layout: [],
      pwdPolicyDialogVisible: false,
      pwdPolicySaving: false,
      formLabelWidth: '120px',
      pwdPolicyForm: {
        mobile: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdPolicyRules: {
        newPassword: [
          { required: true, validator: validateStrongPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    tableHight: function () {
      return window.innerHeight - 305
    },
    loading: function () {
      return this.$store.state.global.ajax_loading
    },
    pwdPolicyRuleList: function () {
      const pwd = String(this.pwdPolicyForm && this.pwdPolicyForm.newPassword
        ? this.pwdPolicyForm.newPassword
        : '')
      return [
        { key: 'len', text: '至少 8 位', ok: pwd.length >= 8 },
        { key: 'letter', text: '包含字母', ok: /[A-Za-z]/.test(pwd) },
        { key: 'digit', text: '包含数字', ok: /\d/.test(pwd) }
      ]
    }
  },
  watch: {
    screenWidth () {
      this.myTeacher.resize()
      this.myStudent.resize()
    }
  },
  methods: {
    safeParseJson (str) {
      if (!str) return null
      try {
        return typeof str === 'string' ? JSON.parse(str) : str
      } catch (e) {
        return null
      }
    },
    getStoredLoginPassword () {
      const prefix = settings && settings.gbs && settings.gbs.db_prefix
        ? settings.gbs.db_prefix
        : 'bell_admin_'
      const k1 = prefix + 'login_pwd'
      const k2 = 'hac_admin_login_pwd'
      const p1 = localStorage.getItem(k1)
      if (p1) return p1
      const p2 = localStorage.getItem(k2)
      return p2 || ''
    },
    getStoredLoginType () {
      const prefix = settings && settings.gbs && settings.gbs.db_prefix
        ? settings.gbs.db_prefix
        : 'bell_admin_'
      return String(localStorage.getItem(prefix + 'login_type') || '')
    },
    isPasswordCompliant (pwd) {
      const s = String(pwd == null ? '' : pwd)
      if (s.length < 8) return false
      if (!/[A-Za-z]/.test(s)) return false
      if (!/\d/.test(s)) return false
      return true
    },
    initPwdPolicyUserInfo () {
      const raw = this.$store && this.$store.state && this.$store.state.login
        ? this.$store.state.login.userInfo
        : ''
      const info = this.safeParseJson(raw) || {}
      this.pwdPolicyForm.mobile = info.mobile || ''
    },
    checkPwdPolicy () {
      const loginType = this.getStoredLoginType()
      if (loginType === 'code') {
        this.pwdPolicyDialogVisible = false
        return
      }
      // const force = localStorage.getItem('bell_admin_pwd_force_change')
      // if (String(force || '') === '1') {
      //   this.initPwdPolicyUserInfo()
      //   this.pwdPolicyDialogVisible = true
      //   this.$nextTick(() => {
      //     const ref = this.$refs.pwdPolicyFormRef
      //     if (ref && ref.clearValidate) ref.clearValidate()
      //   })
      //   return
      // }
      const pwd = this.getStoredLoginPassword()
      if (!pwd) return
      if (this.isPasswordCompliant(pwd)) return
      this.initPwdPolicyUserInfo()
      this.pwdPolicyDialogVisible = true
      this.$nextTick(() => {
        const ref = this.$refs.pwdPolicyFormRef
        if (ref && ref.clearValidate) ref.clearValidate()
      })
    },
    onForceUpdatePassword (formRef) {
      const ref = this.$refs[formRef]
      if (!ref || !ref.validate) return
      ref.validate((valid) => {
        if (!valid) return
        if (this.pwdPolicySaving) return
        this.pwdPolicySaving = true
        ApiUser.changPassword.call(this, this.pwdPolicyForm, () => {
          this.$store.dispatch('setUserLogin', {
            loginName: this.pwdPolicyForm.mobile,
            loginPwd: this.pwdPolicyForm.newPassword
          })
          localStorage.removeItem('bell_admin_pwd_force_change')
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.pwdPolicyDialogVisible = false
          this.pwdPolicyForm.newPassword = ''
          this.pwdPolicyForm.confirmPassword = ''
          this.pwdPolicySaving = false
        }, () => {
          this.pwdPolicySaving = false
        })
      })
    },
    onDown (url) {
      window.open(url)
    },
    goToUrlOther (url) {
      window.open(url)
    },
    goToUrl (url) {
      this.$router.push({
        path: url
      })
    },
    drawPie () {
      const that = this
      ApiHome.getZoneTeacherByPosition.call(this, {}, (list) => {
        let sum = 0
        const data = list.map(item => {
          sum += item.teacherNum
          return { value: item.teacherNum, name: item.position }
        })
        // 绘制图表
        this.myTeacher.setOption({
          title: {
            text: '在校员工情况(总人数：' + sum + ')',
            left: 'center',
            top: 'bottom',
            triggerEvent: true
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'right',
            top: 'middle'
          },
          series: [
            {
              left: '0',
              name: '员工人数',
              center: ['45%', '50%'],
              type: 'pie',
              radius: ['20%', '50%'],
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ],
          color: [
            '#ff7f50', '#87cefa', '#da70d6', '#32cd32', '#6495ed',
            '#ff69b4', '#ba55d3', '#cd5c5c', '#ffa500', '#40e0d0',
            '#1e90ff', '#ff6347', '#7b68ee', '#00fa9a', '#ffd700',
            '#6b8e23', '#ff00ff', '#3cb371', '#b8860b', '#30e0e0'
          ]
        })
        this.myTeacher.on('click', function (params) {
          if (params.componentType === 'title') {
            that.$router.push({
              path: '/education/teacher-management'
            })
          }
        })
      })
    },
    drawLine () {
      const that = this
      ApiHome.getZoneStudentByGrade.call(this, {}, (list) => {
        const xAxis = []
        const seriesData = []
        let sum = 0
        list.map(item => {
          xAxis.push(item.grade)
          sum += item.studentNum
          seriesData.push(item.studentNum)
        })
        this.myStudent.setOption({
          title: {
            text: '在校学生总人数：' + sum + ' (服务期内)',
            left: 'center',
            top: 'bottom',
            triggerEvent: true,
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              minInterval: 1,
              type: 'value'
            }
          ],
          series: [
            {
              name: '学生人数',
              type: 'bar',
              barWidth: '60%',
              data: seriesData,
              itemStyle: {
                normal: {
                  color: function (params) {
                    var colorList = [
                      '#B5C334', '#FCCE10', '#E87C25', '#27727B',
                      '#FE8463', '#9BCA63', '#FAD860', '#F3A43B', '#60C0DD'
                    ]
                    return colorList[params.dataIndex]
                  },
                  label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}'
                  }
                }
              }
            }
          ],
          color: [
            '#ff7f50', '#87cefa', '#da70d6', '#32cd32', '#6495ed',
            '#ff69b4', '#ba55d3', '#cd5c5c', '#ffa500', '#40e0d0',
            '#1e90ff', '#ff6347', '#7b68ee', '#00fa9a', '#ffd700',
            '#6b8e23', '#ff00ff', '#3cb371', '#b8860b', '#30e0e0'
          ]
        })
        this.myStudent.on('click', function (params) {
          if (params.componentType === 'title') {
            that.$router.push({
              path: '/education/student-management'
            })
          }
        })
      })
    }
  },
  mounted () {
    this.checkPwdPolicy()
    /*this.myTeacher = this.$echarts.init(document.getElementById('myTeacher'))
    this.myStudent = this.$echarts.init(document.getElementById('myStudent'))
    this.drawPie()
    this.drawLine()
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        this.screenWidth = window.screenWidth
      })()
    }*/
  },
  activated () {
    this.checkPwdPolicy()
  }
}
